import type { Config } from './config-schema';
import { loadConfigFromHeaders } from './loadConfig.server';

export const loadConfig = async (): Promise<Config | null> => {
    return (await loadConfigFromHeaders()) as Config | null;
};
